<template>
    <div id="main">
        <div v-if="$vuetify.breakpoint.smAndUp">
            <HomeHeader/>
            <HomeAboutApp/>
            <HomeHowItsWork/>
            <HomeFooter/>
        </div>
        <HomeMobile v-else/>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import HomeButton from './HomeButton.vue'
import HomeHeader from './HomeHeader.vue'
import HomeAboutApp from './HomeAboutApp.vue'
import HomeHowItsWork from './HomeHowItsWork.vue'
import HomeFooter from './HomeFooter.vue'
import HomeMobile  from './HomeMobile.vue'
export default {
    name: 'Main',
    data() {
        return {

        }
    },
    components: {
        HomeButton,
        HomeHeader,
        HomeAboutApp,
        HomeHowItsWork,
        HomeFooter,
        HomeMobile
    },
    methods: {
        ...mapMutations(['OPEN_POPUP']),
    },
}
</script>  

<style lang="scss">
    #main {
        .button-blue{
            .v-btn {
                background: #18A0FB  !important;
                color: white !important;
            }
        }
        .logo{
            font-family: Questrial;
            font-weight: 100;
            margin-top: 3px;
            font-size: 60px;
            &.mobile {
                font-size: 42px;
            }
        }
    }
</style>  
        